import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-confirmation-dialog',
  templateUrl: './error-confirmation-dialog.component.html',
  styleUrls: ['./error-confirmation-dialog.component.scss'],
})
export class ErrorConfirmationDialog implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ErrorConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  confirmDialog() {
    this.dialogRef.close(true);
  }
}
